import collectionReducer from '../collectionReducer';

const serverTypeControlToolsReducer = collectionReducer({
    collectionActionName: 'SERVER_TYPE_CONTROL_TOOLS',
    itemActionName: 'SERVER_TYPE_CONTROL_TOOL',
});

function reducer(state, action) {
    const reducedState = serverTypeControlToolsReducer(state, action);
    if (
        action.type === 'SERVER_TYPE_CONTROL_TOOLS_SUCCESS' &&
        action.requestParams?.params?.serverTypeId
    ) {
        const newControlToolIds = Object.values(action.payload.collection).map(ct => ct.id);
        return {
            ...reducedState,
            collection: Object.values(reducedState.collection).reduce((acc, item) => {
                if (
                    item.serverTypeId !== action.requestParams?.params?.serverTypeId ||
                    newControlToolIds.includes(item.id)
                ) {
                    return { ...acc, [item.id]: item };
                }
                return acc;
            }, {}),
        };
    }

    return reducedState;
}

export default reducer;
